import React, { HTMLProps } from 'react'
import { ReactComponent as Folder } from '../assets/icons/folder.svg'
import { ReactComponent as Note } from '../assets/icons/note.svg'
import { ReactComponent as CaseStudy } from '../assets/icons/case-study.svg'
import { ReactComponent as News } from '../assets/icons/news.svg'
import { ReactComponent as Publication } from '../assets/icons/publication.svg'

import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'

interface CategoryProps extends HTMLProps<HTMLDivElement> {
  type: CategoryType
}

export enum CategoryType {
  APPLICATION_NOTE = 'application-note',
  ARTICLE = 'article',
  NEWS = 'news',
  CASE_STUDY = 'case-study',
  PUBLICATION = 'publication',
}

const Category = ({ type, className, ...props }: CategoryProps) => {
    const getIcon = () => {
        switch (type) {
        case CategoryType.APPLICATION_NOTE:
            return Note
        case CategoryType.ARTICLE:
        default:
            return Folder
        case CategoryType.PUBLICATION:
            return Publication
        case CategoryType.NEWS:
            return News
        case CategoryType.CASE_STUDY:
            return CaseStudy
        }
    }
    const Icon = getIcon()
    return (
        <div
            className={twMerge(
                'flex items-center text-black backdrop-blur-md bg-white/70 px-3 py-2 gap-x-2 rounded',
                className,
            )}
            {...props}
        >
            <Icon className='w-4 h-4' />
            <FormattedMessage id={`category.${type}`} tagName='h6' />
        </div>
    )
}

export default Category
